import { styled } from '@fluentui/react';
import { ThirdPartyCookiesDisabled } from '../presentationalComponents/ThirdPartyCookiesDisabled';
import { getCommonThemedStyles } from '../styles/commonStyles';

export const ThirdPartyCookiesDisabledContainer = styled(ThirdPartyCookiesDisabled, getCommonThemedStyles);
